import { useMemo } from "react";
import {
  BodyText,
  Box,
  Container,
  Divider,
  Flex,
  Grid,
  Heading,
  Link,
} from "@utilitywarehouse/hearth-react";
import LogoPurple from "@utilitywarehouse/hearth-svg-assets/lib/logo-full-purple.svg";

import AppleStoreDownload from "../../assets/rebrand_images/app-store-button.svg";
import GooglePlayDownload from "../../assets/rebrand_images/google-play-button.svg";

const Footer: React.FC = () => {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <>
      <Divider />

      <Container backgroundColor="primary" paddingTop="400">
        <Grid
          columns={{ mobile: "1", tablet: "4", desktop: "4" }}
          gap="400"
          spacing="lg"
          alignItems="start"
        >
          <Flex direction="column" gap="300">
            <Box
              width={{ mobile: "140px", desktop: "170px" }}
              height={{ mobile: "41px", desktop: "50px" }}
            >
              <img src={LogoPurple} alt="Utility Warehouse Logo" />
            </Box>

            <Heading size="sm">
              Delivering essential home services nationwide to help you save
              money on your household bills.
            </Heading>
          </Flex>

          <Flex direction="column" gap="400">
            <Flex direction="column" gap="100">
              <Heading size="sm">About us</Heading>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/about-us"
              >
                <BodyText size="md" as="span">
                  About Utility Warehouse
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/about-us/newsroom"
              >
                <BodyText size="md" as="span">
                  Newsroom
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/careers"
              >
                <BodyText size="md" as="span">
                  Careers
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://www.telecomplus.co.uk/"
              >
                <BodyText size="md" as="span">
                  Telecom Plus PLC
                </BodyText>
              </Link>
            </Flex>

            <Flex direction="column" gap="100">
              <Heading size="sm">Resources</Heading>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/legal/information-legal"
              >
                <BodyText size="md" as="span">
                  Information and legal
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://help.uw.co.uk/article/broadband_and_landline/Switching%20Broadband%20Providers/broadband-switching-guidance"
              >
                <BodyText size="md" as="span">
                  Broadband switching guidance
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://help.uw.co.uk/article/mobile/Switching%20Mobile%20Providers/switching-mobile-providers"
              >
                <BodyText size="md" as="span">
                  Mobile switching guidance
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://www.telecomplus.co.uk/corporate-governance"
              >
                <BodyText size="md" as="span">
                  Corporate information
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://s3-eu-west-1.amazonaws.com/pdf.utilitywarehouse.co.uk/telecom-plus-plc-modern-slavery-statement-fy2022-final.pdf"
              >
                <BodyText size="md" as="span">
                  Modern slavery statement
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/word-of-mouth-model"
              >
                <BodyText size="md" as="span">
                  Word of mouth model
                </BodyText>
              </Link>
            </Flex>
          </Flex>

          <Flex direction="column" gap="400">
            <Flex direction="column" gap="100">
              <Heading size="sm">Our services</Heading>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/energy"
              >
                <BodyText size="md" as="span">
                  Energy
                </BodyText>
              </Link>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/broadband"
              >
                <BodyText size="md" as="span">
                  Broadband
                </BodyText>
              </Link>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/mobile"
              >
                <BodyText size="md" as="span">
                  Mobile
                </BodyText>
              </Link>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/insurance"
              >
                <BodyText size="md" as="span">
                  Insurance
                </BodyText>
              </Link>
            </Flex>

            <Flex direction="column" gap="100">
              <Heading size="sm">Support</Heading>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/help"
              >
                <BodyText size="md" as="span">
                  Help centre
                </BodyText>
              </Link>
              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/help/making-a-complaint"
              >
                <BodyText size="md" as="span">
                  Making a complaint
                </BodyText>
              </Link>
              <Link style={{ textDecoration: "none" }} href="https://partner.uw.co.uk/">
                <BodyText size="md" as="span">
                  Find a Utility Warehouse Partner
                </BodyText>
              </Link>
              <Link style={{ textDecoration: "none" }} href="https://uw.co.uk/legal/cookies-policy">
                <BodyText size="md" as="span">
                  Cookie settings
                </BodyText>
              </Link>
            </Flex>
          </Flex>

          <Flex direction="column" gap="400">
            <Flex direction="column" gap="100">
              <Heading size="sm">Quick links</Heading>

              <Link
                style={{ textDecoration: "none" }}
                href="https://login.uw.co.uk/"
              >
                <BodyText size="md" as="span">
                  Utility Warehouse Partners login
                </BodyText>
              </Link>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/quote"
              >
                <BodyText size="md" as="span">
                  New customer sign-up
                </BodyText>
              </Link>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/uw-for-business"
              >
                <BodyText size="md" as="span">
                  Utility Warehouse for Business
                </BodyText>
              </Link>

              <Link
                style={{ textDecoration: "none" }}
                href="https://uw.co.uk/about-us/uw-foundation"
              >
                <BodyText size="md" as="span">
                  The Utility Warehouse Foundation
                </BodyText>
              </Link>
            </Flex>

            <Flex direction="column" gap="100">
              <Heading size="sm">Download our mobile app</Heading>

              <Flex gap="100">
                <Link href="https://apps.apple.com/gb/app/uw-clubhouse/id1087299862">
                  <img src={AppleStoreDownload} alt="Download on Apple Store" />
                </Link>

                <Link href="https://play.google.com/store/apps/details?id=com.utilitywarehouse.clubhouse&hl=en_GB">
                  <img src={GooglePlayDownload} alt="Get it on Google Play" />
                </Link>
              </Flex>
            </Flex>
          </Flex>
        </Grid>
      </Container>

      <Divider />

      <Container backgroundColor="primary" paddingTop="200" paddingBottom="200">
        <BodyText size="sm">
          © Utility Warehouse Limited {year}. Registered in England. Company
          number: 04594421. Utility Warehouse Limited is authorised and
          regulated by the Financial Conduct Authority
        </BodyText>
      </Container>
    </>
  );
};

export default Footer;
